import isEmpty from "lodash.isempty";
import { paymentService } from "../services/payment";
import useEnv from "./useEnv";

const useSettings = () => {
    const { getEnv, isEnvTruthy } = useEnv();

    const allowServing = isEnvTruthy('SHOW_SERVING');

    let preselectPayment = false;

    // check if bank selection modal can be shown in the environment (N.B. can be overridden if VITE_NETAXEPT_PRESELECT_BANKS or VITE_WORLDLINE_PRESELECT_BANKS contains banks)
    if (isEnvTruthy('PRESELECT_PAYMENT')) {
        preselectPayment = true;
    }

    /**
     * Helper for checking if the visibility of the bank selection modal needs to be changed.
     */
    const checkModalVisibilityOverrides = () => {
        if (!preselectPayment && paymentService.paymentService === paymentService.PAYMENTMETHODS.TINK) {
            // override preselect payment modal setting from false to true, if Netaxept or Worldline banks have been defined in an environment where bank selection modal is disabled (user chooses between Nets/Worldline banks (redirects to chosen bank in Nets/Worldline) or 'Online banks' (redirected to Tink))
            preselectPayment = true;
            redirectToTinkForPayment = true; // redirect to Tink for payment method selection instead of showing Tink's banks in MyRopo
        }
    }

    let includedNetsBanks = [];
    let redirectToTinkForPayment = false;

    // check if there are any banks from Netaxept that should be included in the payment method selection
    const netaxeptPreselectBanks = getEnv('NETAXEPT_PRESELECT_BANKS');
    if (typeof netaxeptPreselectBanks !== 'undefined' && !isEmpty(netaxeptPreselectBanks)) {
        includedNetsBanks = netaxeptPreselectBanks.replace(' ', '').split(',');
        
        // check if visibility of the bank selection modal needs to be changed
        checkModalVisibilityOverrides();
    }

    let includedWorldlineBanks = [];
    const worldlinePreselectBanks = getEnv('WORLDLINE_PRESELECT_BANKS');

    // check if there are any banks from Worldline that should be included in the payment method selection
    if (worldlinePreselectBanks && worldlinePreselectBanks.trim() !== '') {
        includedWorldlineBanks = worldlinePreselectBanks.replace(' ', '').split(',');
        
        // check if visibility of the bank selection modal needs to be changed
        checkModalVisibilityOverrides();
    }

    let paymentlimit = 0;

    // check if there is an allowed maximum amount for an invoice's open amount that can still be paid in MyRopo
    const paymentLimitSetting = getEnv('PAYMENT_LIMIT');
    if (typeof paymentLimitSetting !== 'undefined' && paymentLimitSetting > 0) {
        paymentlimit = parseFloat(paymentLimitSetting);
    }

    const showChatButton = isEnvTruthy('SHOW_CHAT');
    const showMessageCenterButton = isEnvTruthy('MESSAGECENTER');
    const showChatDisabledNotice = isEnvTruthy('SHOW_CHAT_DISABLED_NOTICE');

    return {
        allowServing,
        preselectPayment,
        redirectToTinkForPayment,
        includedNetsBanks,
        includedWorldlineBanks,
        paymentlimit,
        showChatButton,
        showMessageCenterButton,
        showChatDisabledNotice
    }
}

export default useSettings;
